<template>
  <div class="bg--white">
    <sub-page-header :title="$t('safety_numbers.title')" />
    <div
      class="container "
      :class="{ 'container--with-divider': config.showSafetyNumbersAdd }"
    >
      <p v-t="'safety_numbers.info'"></p>
      <h3 class="bolder" v-t="'safety_numbers.admin_number'"></h3>
      <p v-t="'safety_numbers.admin_number_info'"></p>

      <label
        class="label-heading"
        v-if="onlyAdminNumbers && onlyAdminNumbers.length > 0"
        v-t="'safety_numbers.admin_numbers_set'"
      ></label>

      <SafetyNumber
        :model="data"
        v-for="(data, index) in onlyAdminNumbers"
        :key="'admin-' + index"
        v-on:remove-number="confirmNumberRemoval"
      ></SafetyNumber>

      <SafetyNumberAdd
        v-if="!initPending && numbersAvailable"
        :fafIndicator="2"
        v-on:add-number="addNumber"
      />
      <AppLoadingAni v-if="initPending || (pending && addingAdminNumber)" />
      <div
        v-if="$store.state.safetyNumbers.error && addingAdminNumber"
        class="error-block"
        v-t="`api_errors.${$store.state.safetyNumbers.error}`"
      ></div>
    </div>

    <div class="container" v-if="config.showSafetyNumbersAdd">
      <h3 class="bolder" v-t="'safety_numbers.safety_number'"></h3>
      <p v-t="'safety_numbers.safety_number_info'"></p>
      <label
        class="label-heading"
        v-if="onlySafetyNumbers && onlySafetyNumbers.length > 0"
        v-t="'safety_numbers.safety_numbers_set'"
      ></label>

      <SafetyNumber
        :model="data"
        v-for="(data, index) in onlySafetyNumbers"
        :key="'safe-' + index"
        v-on:remove-number="confirmNumberRemoval"
      ></SafetyNumber>

      <SafetyNumberAdd
        v-if="!initPending && numbersAvailable"
        :fafIndicator="1"
        v-on:add-number="addNumber"
      />
      <AppLoadingAni v-if="initPending || (pending && addingSafetyNumber)" />
      <div
        v-if="$store.state.safetyNumbers.error && addingSafetyNumber"
        class="error-block"
        v-t="`api_errors.${$store.state.safetyNumbers.error}`"
      ></div>
    </div>

    <modal :show="this.showModal">
      <AlertIcon slot="icon" class="icon" />
      <h3 slot="header" v-t="'general.are_you_sure'"></h3>
      <i18n tag="p" slot="body" path="safety_numbers.really_remove_number">
        <strong class="no-wrap" place="number">{{
          numberToRemove | PrettyNumber
        }}</strong>
      </i18n>

      <button
        slot="footer"
        @click="removeNumber(numberToRemove)"
        class="button button--alert w-100"
        v-t="'safety_numbers.remove_number'"
      ></button>
      <button
        slot="footer"
        @click="closeModal"
        class="button button--gray w-100"
        v-t="'general.cancel'"
      ></button>
    </modal>
  </div>
</template>

<script>
import SubPageHeader from '@/components/SubPageHeader';
import SafetyNumber from '@/components/SafetyNumber';
import SafetyNumberAdd from '@/components/SafetyNumberAdd';
import AppLoadingAni from '@/components/AppLoadingAni';
import Modal from '@/components/Modal';
import AlertIcon from '@/assets/svg/alert.svg?inline';
import PrettyNumber from '@/filters/PrettyNumber';
import serviceClassConfig from '@/service-class-config.json';
import { mapGetters } from 'vuex';

export default {
  components: {
    SubPageHeader,
    SafetyNumber,
    SafetyNumberAdd,
    AppLoadingAni,
    Modal,
    AlertIcon,
  },
  data() {
    return {
      showModal: false,
      numberToRemove: null,
      addingAdminNumber: false,
      addingSafetyNumber: false,
    };
  },
  filters: {
    PrettyNumber,
  },
  computed: {
    ...mapGetters('safetyNumbers', [
      'safetyNumbers',
      'pending',
      'initPending',
      'getFafInd',
    ]),
    ...mapGetters('user', ['user']),
    onlyAdminNumbers() {
      return this.safetyNumbers.filter(number => number.fafIndicator === 2);
    },
    onlySafetyNumbers() {
      return this.safetyNumbers.filter(number => number.fafIndicator === 1);
    },
    numbersAvailable() {
      return this.safetyNumbers.length < 2;
    },
    config() {
      return serviceClassConfig[this.user.serviceClassGroup];
    },
  },
  created() {
    this.$store.dispatch('safetyNumbers/fetch');
  },
  methods: {
    confirmNumberRemoval(number) {
      this.numberToRemove = number;
      this.showModal = true;
    },
    async removeNumber(number) {
      this.addingAdminNumber = false;
      this.addingSafetyNumber = false;
      const fafInd = this.getFafInd(number);
      if (fafInd == 2) {
        this.addingAdminNumber = true;
      } else if (fafInd == 1) {
        this.addingSafetyNumber = true;
      }
      this.showModal = false;
      this.numberToRemove = null;
      const data = {
        fafNumber: number,
      };
      await this.$store.dispatch('safetyNumbers/removeNumber', data);
    },
    async addNumber(payload) {
      this.addingAdminNumber = false;
      this.addingSafetyNumber = false;
      if (payload.fafIndicator == 2) {
        this.addingAdminNumber = true;
      } else if (payload.fafIndicator == 1) {
        this.addingSafetyNumber = true;
      }
      await this.$store.dispatch('safetyNumbers/addNumber', payload);
    },
    onClose() {
      console.log('should close modal');
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.bg--white {
  margin-bottom: 30px;
}
</style>
